import gql from 'graphql-tag';

export default gql`
    mutation($organizationId: String!, $id: String!, $otpToken: String!,) {
        removeApiKeys(organizationId: $organizationId, id: $id, otpToken: $otpToken,)
    }
`;
